export { default as Brands } from './brands'
export { default as BrandABB } from './brand-abb'
export { default as BrandAccenture } from './brand-accenture'
export { default as BrandAppenzeller } from './brand-appenzeller'
export { default as BrandArvato } from './brand-arvato'
export { default as BrandASA } from './brand-asa'
export { default as BrandBMWGroup } from './brand-bmw-group'
export { default as BrandCreditSuisse } from './brand-credit-suisse'
export { default as BrandEbookers } from './brand-ebookers'
export { default as BrandMars } from './brand-mars'
export { default as BrandPost } from './brand-post'
export { default as BrandProHelvetia } from './brand-prohelvetia'
export { default as BrandRoche } from './brand-roche'
export { default as BrandSAP } from './brand-sap'
export { default as BrandSBB } from './brand-sbb'
export { default as BrandSwatch } from './brand-swatch'
export { default as BrandSwisslife } from './brand-swisslife'
export { default as BrandTelekom } from './brand-telekom'
export { default as BrandUBS } from './brand-ubs'
export { default as BrandUnionInvestment } from './brand-union-investment'
export { default as BrandWaltDisney } from './brand-walt-disney'
export { default as IconLogo } from './icon-logo'
export { default as IconPlus } from './icon-plus'
export { default as IconShopifyPartner } from './icon-shopify-partner'
export { default as IconExternal } from './icon-external'
export { default as IconGitHub } from './icon-github'
export { default as IconLinkedin } from './icon-linkedin'
export { default as IconTwitter } from './icon-twitter'
export { default as IconInstagram } from './icon-instagram'
export { default as IconSocial } from './icon-social'
export { default as IconTabs } from './icon-tabs'
export { default as IconDesign } from './icon-design'
export { default as IconDevelopment } from './icon-development'
export { default as IconMarketing } from './icon-marketing'
export { default as IconSupport } from './icon-support'
export { default as IconActive } from './icon-active'
